import React from 'react';
import _ from 'lodash';
import { useParameterizedQuery } from 'react-fetching-library';
import { Stack, Button } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import BankTransferDetailsModal from './BankTransferDetailsModal';
import { SnackbarAlert } from '../../../components-core/SnackbarAlert';
import { createTransactionAction } from '../../../services/request';

const SettlementsTable = ({ payments, orderQuery }) => {
  const [open, setOpen] = React.useState(false);
  const [payment, setPayment] = React.useState({});
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const { query } = useParameterizedQuery(createTransactionAction);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };


  const handleOpen = payment => {
    setPayment(payment);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handlePay = async payment => {
    const data = {
      payment_id: payment.id
    };

    const params = new URLSearchParams(data).toString();
    const { payload, error, loading } = await query(params);

    if (!error) {
      window.open(payload.url, '_blank');
    }
  };

  const columns = [
    { field: 'contract_number', headerName: 'Numer zamówienia', flex: 0.1 },
    { field: 'title', headerName: 'Tytuł płatności', flex: 0.8 },
    { field: 'to_pay', headerName: 'Kwota (zł)', flex: 0.1 },
    { field: 'Zapłać całość', headerName: '', width: 320, resizable: false, renderCell: params => (
      <Stack direction="row" spacing={2}>
        {params.row.paid
          ? <Button variant="contained" disabled sx={{ width: '300px' }}>Opłacono</Button>
          : <>
            <Button
              color="primary"
              variant="contained"
              onClick={() => handlePay(params.row)}
            >
          Zapłać Online
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => handleOpen(params.row)}
            >
          Dane do przelewu
            </Button>
          </>}
      </Stack>
    ) }
  ];

  return (
    <>
      <DataGridPro
        autoHeight
        rows={payments}
        columns={columns}
        pageSize={25}
        rowsPerPageOptions={[5, 10, 25]}
        pagination
        localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
      />
      <BankTransferDetailsModal
        open={open}
        number="89 2030 0045 1110 0000 0273 4970"
        title={payment.title}
        amount={payment.to_pay}
        handleClose={handleClose}
      />
      <SnackbarAlert open={openSnackbar} severity="error" message="Wystąpił błąd" onClose={handleCloseSnackbar} />
    </>
  );
};

export default SettlementsTable;
